import {
    Component,
    effect,
    ElementRef,
    HostListener,
    inject, OnInit,
    Signal,
    signal,
    viewChild,
    viewChildren
} from '@angular/core';
import {ProductCardComponent} from "../shared/product-card/product-card/product-card.component";
import {LamelareaStore} from "../shared/product-card/product-card/lamelarea.store";
import {NgClass} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";
import {SaveComponentComponent} from "../project-records/save-component/save-component.component";
import {InfoAreaComponent} from "./info-area/info-area.component";
import {CanvasComponent} from "../threejs/components/canvas/canvas.component";
import {FooterComponent} from "./footer/footer.component";
import {HeaderComponent} from "./header/header.component";
import {RendererStore} from "../threejs/store/Renderer.store";
import {RenderingService} from "../threejs/service/rendering.service";
import {translate} from "../shared/translate/translate";
import {BetaNoticeComponent} from "./beta-notice/beta-notice.component";
import {InputComponent} from "../shared/form-elements/input/input/input.component";

@Component({
    selector: 'app-main-layout',
    imports: [
        ProductCardComponent,
        NgClass,
        TranslatePipe,
        SaveComponentComponent,
        TranslatePipe,
        InfoAreaComponent,
        CanvasComponent,
        FooterComponent,
        HeaderComponent,
        BetaNoticeComponent,
        InputComponent,

    ],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss',
    //changeDetection : ChangeDetectionStrategy.OnPush TODO: Korjaa määrälaskentavalikon tapa sulkeutua ja voit ottaa tämän käyttöön.
})
export class MainLayoutComponent implements OnInit {
    private readonly elementRef = inject(ElementRef);
    private readonly rendererStore = inject(RendererStore);
    private readonly renderingService = inject(RenderingService);

    readonly lamelareaStore = inject(LamelareaStore);

    private readonly lamellaAreaGroupContainer = viewChild<ElementRef<HTMLDivElement>>('lamellaAreaGroups');
    private readonly lamelAreaGroups = viewChildren('lamelAreaGroup');
    private readonly lamelAreaGroupInputs: Signal<readonly ElementRef[]> = viewChildren('lamelAreaGroupInput');
    protected readonly groupListeners: {[key:string]: any} = {}

    private readonly newGroupKey = translate('LAMELLA_AREA_GROUP.NEW_GROUP');
    private readonly removeGroupKey = translate('LAMELLA_AREA_GROUP.REMOVE_GROUP_CONFIRMATION');

    constructor() {
        effect(() => {
            this.lamelAreaGroups().forEach((group: any) => {
                // Check if not defined
                if (!group ) { return; }

                // reference has changed delete old listener
                if(this.groupListeners?.[group.nativeElement.id]) {
                    delete this.groupListeners[group.nativeElement.id];
                }

                group.nativeElement.addEventListener('dblclick', this.setGroupNameChangeActive.bind(this, group.nativeElement.id));

                // Observe the group for removal
                const observer = new MutationObserver((mutations)=>{
                    if(!this.elementRef.nativeElement.contains(group.nativeElement)){
                        group.nativeElement.removeEventListener('dblclick', this.setGroupNameChangeActive.bind(this, group.nativeElement.id));
                        observer.disconnect();
                    }
                });

                observer.observe(group.nativeElement, { childList: true });

                //weakRef enables listener to be garbage collected
                this.groupListeners[group.nativeElement.id] = { listener: new WeakRef(observer), change: signal(false) };
            });
        });
    }

    async ngOnInit() {
        if ( await this.lamelareaStore.fetchProjectIfQueryParams() ){ return; }
        if ( await this.lamelareaStore.setInitialProduct() ){ return; }
    }

    @HostListener('document:click', ['$event'])
    onOutsideClick(event: MouseEvent) {
        if(!this.lamellaAreaGroupContainer()?.nativeElement.contains(event.target as Node)){
            this.lamelAreaGroups().forEach((elemRef: any)=> this.groupListeners?.[elemRef.nativeElement.id].change.set(false));
        }
    }

    setGroupNameChangeActive(id: string, event: MouseEvent) {
        for (const groupId in this.groupListeners){
            if (groupId === id) { continue; }
            // commit any other inputs
            this.groupListeners[groupId].change.set(false);
        }
        this.groupListeners?.[id]?.change?.set(true);
        this.lamelAreaGroupInputs().find((input: any) => input?.nativeElement?.id === id)?.nativeElement?.focus()
    }

    renameGroup(id: string, name: any) {
        const newName = name;
        this.lamelareaStore.renameLamellaAreaGroup(id, newName);
        this.groupListeners?.[id]?.change.set(false);
    }

    addGroup() {
        this.lamelareaStore.addLamellaAreaGroup(this.newGroupKey()+' '+(this.lamelareaStore.lamellaAreaGroups().length+1));
    }

    removeGroup(id: string) {
        if(!confirm(this.removeGroupKey())) return;
        this.lamelareaStore.removeLamellaAreaGroup(id);
        if(this.lamelareaStore.selectedLamellaAreaGroupId() === id){
            this.clearCanvas();
            this.lamelareaStore.setSelectLamelareaGroup(this.lamelareaStore.lamellaAreaGroups()[0]?.id);
        }
    }

    selectLamelAreaGroup(id: string) {
        if(this.lamelareaStore.selectedLamellaAreaGroupId() === id) return;
        this.clearCanvas();
        this.lamelareaStore.setSelectLamelareaGroup(id);
    }

    private clearCanvas(){
        this.renderingService.stopAnimate();
        this.rendererStore.clearCanvas();
    }
}
